module.exports = __webpack_public_path__ + "img/sportsbook-th.3acf2d83.png";